const LOG_TYPES = {
  REGISTER: "REGISTER",
  LOGIN: "LOGIN",
  CONVERT_CUSTOMER: "CONVERT_CUSTOMER",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  RESET_PASSWORD: "RESET_PASSWORD",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  AVATAR_UPDATED: "AVATAR_UPDATED",
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
  CONVERT: "CONVERT",
  ORDER: "ORDER",
  WALLET: "WALLET",
  CREATE_CONVERSION: "CREATE_CONVERSION",
  EDIT_CONVERSION: "EDIT_CONVERSION",
  // docs
  UPLOAD_DOCS: "UPLOAD_DOCS",
  OVERWRITE_DOCS: "OVERWRITE_DOCS",
  CHANGE_DOC_STATUS: "CHANGE_DOC_STATUS",
  // bank accs
  ADD_BANK_ACCOUNT: "ADD_BANK_ACCOUNT",
  EDIT_BANK_ACCOUNT: "EDIT_BANK_ACCOUNT",
  DELETE_BANK_ACCOUNT: "DELETE_BANK_ACCOUNT",
  // todos
  ADD_TODO: "ADD_TODO",
  EDIT_TODO: "EDIT_TODO",
  DELETE_TODO: "DELETE_TODO",
  // leads
  UPDATE_LEAD_STAGE: "UPDATE_LEAD_STAGE",
  // customers
  EDIT_CUSTOMER_INFO: "EDIT_CUSTOMER_INFO",
  PROFILE_COMPLETED: "PROFILE_COMPLETED",

  // 2fa
  ENABLE_2FA: "ENABLE_2FA",
  DISABLE_2FA: "DISABLE_2FA",
  DEPOSIT_CASHBACK: "DEPOSIT_CASHBACK",
  // requests
  IB_REQUEST: "IB_REQUEST",
  UPDATE_IB_REQUEST: "UPDATE_IB_REQUEST",
  CREATE_ACCOUNT_REQUEST: "CREATE_ACCOUNT_REQUEST",
  UPDATE_ACCOUNT_REQUEST: "UPDATE_ACCOUNT_REQUEST",
  LEVERAGE_REQUEST: "LEVERAGE_REQUEST",
  UPDATE_LEVERAGE_REQUEST: "UPDATE_LEVERAGE_REQUEST",
  // create trading accounts
  ACCOUNT_CREATED: "ACCOUNT_CREATED",
  // transactions
  FX_DEPOSIT: "FX_DEPOSIT",
  FX_DEPOSIT_UPDATE: "FX_DEPOSIT_UPDATE",
  FX_WITHDRAW: "FX_WITHDRAW",
  FX_WITHDRAW_UPDATE: "FX_WITHDRAW_UPDATE",
  FX_INTERNAL_TRANSFER: "FX_INTERNAL_TRANSFER",
  FX_INTERNAL_TRANSFER_UPDATE: "FX_INTERNAL_TRANSFER_UPDATE",
  INTERNAL_TRANSFER_UPDATE: "INTERNAL_TRANSFER_UPDATE",
  FX_CREDIT_UPDATE: "FX_CREDIT_UPDATE",
  FX_DEPOSIT_AUTO: "FX_DEPOSIT_AUTO",
  FX_WITHDRAW_AUTO: "FX_WITHDRAW_AUTO",
  FX_INTERNAL_TRANSFER_AUTO: "FX_INTERNAL_TRANSFER_AUTO",
  APPROVING_DEPOSIT: "APPROVING_DEPOSIT",
  REJECTION_DEPOSIT: "REJECTION_DEPOSIT",
  APPROVING_WITHDRAW: "APPROVING_WITHDRAW",
  REJECTION_WITHDRAW: "REJECTION_WITHDRAW",
  INTERNAL_TRANSFER: "INTERNAL_TRANSFER",
  WITHDRAW_FAILED: "WITHDRAW_FAILED",
  DEPOSIT_FAILED: "DEPOSIT_FAILED",
  APPROVING_DEPOSIT_FX: "APPROVING_DEPOSIT_FX",
  REJECTION_DEPOSIT_FX: "REJECTION_DEPOSIT_FX",
  APPROVING_WITHDRAW_FX: "APPROVING_WITHDRAW_FX",
  REJECTION_WITHDRAW_FX: "REJECTION_WITHDRAW_FX",
  APPROVING_INTERNAL_TRANSFER: "APPROVING_INTERNAL_TRANSFER",
  REJECTION_INTERNAL_TRANSFER: "REJECTION_INTERNAL_TRANSFER",

  // users
  CREATE_USER: "CREATE_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",
  // teams
  CREATE_TEAM: "CREATE_TEAM",
  UPDATE_TEAM: "UPDATE_TEAM",
  ADD_TEAM_MEMBER: "ADD_TEAM_MEMBER",
  DELETE_TEAM_MEMBER: "DELETE_TEAM_MEMBER",
  // roles
  ROLES: "ROLES",
  UPDATE_ROLE: "UPDATE_ROLE",
  DELETE_ROLE: "DELETE_ROLE",
  // uncategorized
  CREATE_LEAD: "CREATE_LEAD",
  ASSIGN_AGENT: "ASSIGN_AGENT",
  CHANGE_CALL_STATUS: "CHANGE_CALL_STATUS",
  SYSTEM_EMAIL: "SYSTEM_EMAIL",

  ACCOUNT_TYPE_CREATED: "ACCOUNT_TYPE_CREATED",
  ACCOUNT_TYPE_UPDATED: "ACCOUNT_TYPE_UPDATED",
  IB_ACCOUNT_CREATED: "IB_ACCOUNT_CREATED",
  TRADING_ACCOUNT_TYPE_CHANGED: "TRADING_ACCOUNT_TYPE_CHANGED",
  TRADING_ACCOUNT_UPDATED: "TRADING_ACCOUNT_UPDATED",
  TRADING_ACCOUNT_PLATFORM_UPDATED: "TRADING_ACCOUNT_PLATFORM_UPDATED",
  TRADING_ACCOUNT_LEVERAGE_CHANGED: "TRADING_ACCOUNT_LEVERAGE_CHANGED",
  TRADING_ACCOUNT_ACCESS_CHANGED: "TRADING_ACCOUNT_ACCESS_CHANGED",
  SYNC_DEALS_STARTED: "SYNC_DEALS_STARTED",
  SYNC_DEALS_COMPLETED: "SYNC_DEALS_COMPLETED",

  // CAMPAIGNS
  ADD_CAMPAIGN_TEMPLATE: "ADD_CAMPAIGN_TEMPLATE",
  EDIT_CAMPAIGN_TEMPLATE: "EDIT_CAMPAIGN_TEMPLATE",
  DELETE_CAMPAIGN_TEMPLATE: "DELETE_CAMPAIGN_TEMPLATE",
  CAMPAIGN_UNSUBSCRIBE: "CAMPAIGN_UNSUBSCRIBE",
  ADD_CAMPAIGN: "ADD_CAMPAIGN",
  EDIT_CAMPAIGN: "EDIT_CAMPAIGN",
  DELETE_CAMPAIGN: "DELETE_CAMPAIGN",
  RUN_CAMPAIGN: "RUN_CAMPAIGN",
  // IB
  LINK_IB: "LINK_IB",
  UNLINK_IB: "UNLINK_IB",
  // MASTER AGREEMENT
  CREATE_MASTER_AGREEMENT: "CREATE_MASTER_AGREEMENT",
  UPDATE_MASTER_AGREEMENT: "UPDATE_MASTER_AGREEMENT",
  // SHARED
  CREATE_SHARED_AGREEMENT: "CREATE_SHARED_AGREEMENT",
  UPDATE_SHARED_AGREEMENT: "UPDATE_SHARED_AGREEMENT",
  // Delete agreement
  DELETE_AGREEMENT: "DELETE_AGREEMENT",
  // Copy Trading
  PROFILE_REQUESTED: "PROFILE_REQUESTED",
  PROFILE_APPROVED: "PROFILE_APPROVED",
  PROFILE_REJECTED: "PROFILE_REJECTED",
  
  //Create MAM profile 
  CREATE_MAM_PROFILE : "CREATE_MAM_PROFILE",

  PROFILE_LINK_REQUESTED: "PROFILE_LINK_REQUESTED",
  PROFILE_LINK_APPROVED: "PROFILE_LINK_APPROVED",
  PROFILE_LINK_REJECTED: "PROFILE_LINK_REJECTED",

  PROFILE_UNLINK_REQUESTED: "PROFILE_UNLINK_REQUESTED",
  PROFILE_UNLINK_APPROVED: "PROFILE_UNLINK_APPROVED",
  PROFILE_UNLINK_REJECTED: "PROFILE_UNLINK_REJECTED",

  INVESTOR_REQUESTED: "INVESTOR_REQUESTED",
  INVESTOR_APPROVED: "INVESTOR_APPROVED",
  INVESTOR_REJECTED: "INVESTOR_REJECTED",
  USER_EMAIL: "USER_EMAIL",

  // IP access control
  IP_ATTEMPT_FAILED: "IP_ATTEMPT_FAILED",
  IP_BLOCKED_ATTEMPT: "IP_BLOCKED_ATTEMPT",
  IP_AUTO_BLOCKED: "IP_AUTO_BLOCKED",
  IP_BLOCK_CHECK_ERROR: "IP_BLOCK_CHECK_ERROR",
  IP_BLOCK_ADDED: "IP_BLOCK_ADDED",
  IP_BLOCK_REMOVED: "IP_BLOCK_REMOVED",
  IP_SECURITY_CONFIG_UPDATED: "IP_SECURITY_CONFIG_UPDATED",

  CRM_LOGIN: "CRM_LOGIN",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGIN_2FA_FAILED: "LOGIN_2FA_FAILED",
  ACCOUNT_LOCKED: "ACCOUNT_LOCKED",
  LOGOUT: "LOGOUT",
  SESSIONS_REVOKED: "SESSIONS_REVOKED",
  IMPERSONATION_LINK_CREATED: "IMPERSONATION_LINK_CREATED",
  IMPERSONATION_LOGIN: "IMPERSONATION_LOGIN",
};

const LOG_LEVELS = {
  0: "DEBUG",
  1: "INFO",
  2: "WARN",
  3: "ERROR",
};

const TRIGGERED_BY = {
  0: "Client",
  1: "User"
};

export {
  LOG_LEVELS,
  LOG_TYPES,
  TRIGGERED_BY,
};